/* eslint-disable import/prefer-default-export */
import dayjs from 'dayjs';
import { TaskStatus, TASK_STATUS_V2 } from '../const/task';
import { getSystemCode } from './systemCode';
import { ParamsUtil } from './params';


export function parseTaskV2Status({ taskStatus, actionStep } = {}) {
  if (taskStatus === TASK_STATUS_V2.INIT) {
    return TaskStatus.TO_ACCEPT;
  }
  if (taskStatus === TASK_STATUS_V2.RUNNING) {
    return TaskStatus.DOING;
  }
  if (taskStatus === TASK_STATUS_V2.FINISHED && actionStep === 1) {
    return TaskStatus.CAN_DONE;
  }
  if (taskStatus === TASK_STATUS_V2.FINISHED && actionStep === 2) {
    return TaskStatus.DONE;
  }
  return TaskStatus.TO_ACCEPT;
}


export function mapTaskV2(t) {
  const {
    totalProgress,
    btnName,
    btnLink,
    titleBarUrl,
    addtionalDesc,
    guideAwardDesc,
    actionStep,
    expertId,
    offerWorth,
    offerExpireDate,
    guideDesc,
    taskImgUrl,
    additionalDesc,
    currentProgress,
    taskStatus,
    taskCode,
    taskGroupCode,
    expireDate,
    taskGuid,
    couponInfo,
    ...others
  } = t;
  const status = parseTaskV2Status(t);
  const english = guideDesc && guideDesc.indexOf(',');
  const chinese = guideDesc && guideDesc.indexOf('，');
  const commaIndex = english !== -1 ? english : chinese;
  const alipayTitle = commaIndex !== -1 ? (guideDesc && guideDesc.slice(0, commaIndex)) : guideDesc;
  return {
    ...others,
    additionalDesc,
    title: getSystemCode() === 65 ? alipayTitle : (guideDesc + guideAwardDesc),
    end: dayjs(status === TaskStatus.CAN_DONE ? offerExpireDate : expireDate).format('MM-DD HH:mm 到期'),
    surplus: status === TaskStatus.CAN_DONE ? offerExpireDate : expireDate,
    amount: offerWorth || 0,
    expertId,
    taskGuid,
    shouldAccept: taskStatus === TASK_STATUS_V2.INIT,
    taskCode,
    taskStatus,
    status,
    buttonName: btnName,
    btnLink,
    taskGroupCode,
    target: totalProgress,
    process: currentProgress,
    actionStep,
    titleBarUrl,
    taskImgUrl,
    guideDesc,
    couponInfo,
  };
}

export function newMapTaskV2(t) {
  const {
    totalProgress,
    btnName,
    btnLink,
    titleBarUrl,
    addtionalDesc,
    guideAwardDesc = '',
    actionStep,
    expertId,
    offerWorth,
    offerExpireDate,
    guideDesc,
    taskImgUrl,
    additionalDesc,
    currentProgress,
    taskStatus,
    taskCode,
    taskGroupCode,
    expireDate,
    taskGuid,
    couponInfo,
    ...others
  } = t;
  const status = parseTaskV2Status(t);
  return {
    ...others,
    additionalDesc,
    title: guideDesc + guideAwardDesc,
    end: dayjs(status === TaskStatus.CAN_DONE ? offerExpireDate : expireDate).format('MM-DD HH:mm 到期'),
    surplus: status === TaskStatus.CAN_DONE ? offerExpireDate : expireDate,
    amount: offerWorth || 0,
    expertId,
    taskGuid,
    shouldAccept: taskStatus === TASK_STATUS_V2.INIT,
    taskCode,
    taskStatus,
    status,
    buttonName: btnName,
    btnLink,
    taskGroupCode,
    target: totalProgress,
    process: currentProgress,
    actionStep,
    titleBarUrl,
    taskImgUrl,
    guideDesc,
    couponInfo,
  };
}

export function mapBusinessInfo(v) {
  const {
    taskCode: taskcode, taskName: taskname, taskGroupCode, userTags,
    progress, taskSendType,
  } = v;

  return {
    subsceneNameEn: 'platform_points_alipayshp',
    sceneNameEn: 'platform_points',
    userTag: (userTags || []).map((o) => o.value),
    taskcode,
    taskname,
    taskGroupCode,
    currentProgress: progress,
    taskSendType,
    adsource: ParamsUtil.getParam('adsource'),
  };
}
